import { render } from "./App.vue?vue&type=template&id=5d0aa4f6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5d0aa4f6&lang=css"

import exportComponent from "F:\\kc\\黄石城发建设内部招投标平台\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__